import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const fetchAssessments = async () => {
    return apiWrapper({
      fetch,
      url: 'assessment/list',
      options: {
        method: 'GET'
      }
    });
  }

  const fetchAssessmentMods = async () => {
    return apiWrapper({
      fetch,
      url: 'assessment/mods/list',
      options: {
        method: 'GET'
      }
    });
  }

  return {
    fetchAssessments,
    fetchAssessmentMods
  }
}
